import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeploymentService } from 'src/app/core/services/deployment.service';

@Component({
  selector: 'app-poweroff-confirmation',
  templateUrl: './poweroff-confirmation.component.html',
  styleUrls: ['./poweroff-confirmation.component.scss']
})
export class PoweroffConfirmationComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PoweroffConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { depName: string, action: string },
    private snackBar: MatSnackBar
  ) { }

  depName: string = this.data.depName;
  inpVal: string = "";
  action: string = this.data.action;

  ngOnInit(): void {

  }

  onCancel() {
    this.dialogRef.close(false)
  }

  onSubmit() {
    this.dialogRef.close(true);
    this.snackBar.open("Deployment Power Off in progress.", "Ok", {
      duration: 5000
    })
  }

}
